import React from 'react';
import DetailInViewWrapper from 'component/common/DetailInViewWrapper/DetailInViewWrapper';
import Prerender from 'component/common/Prerender/Prerender';
import ReviewSummary from 'component/page/detail/Review/ReviewSummary/ReviewSummary';
import ReviewOverlay from 'component/page/detail/Review/ReviewOverlay/ReviewOverlay';
import { Accordion } from '@drone-js/core';
import { connect, useSelector } from 'react-redux';
import { selectCmsFromBootstrap, selectPrerenderStateFromBootstrap } from 'store/slice/bootstrap';
import { selectExpandedAccordionFromDetailState } from 'component/page/detail/store/detail.selectors';
import { mapStateToProps, ReviewSectionProps } from 'component/page/detail/Review/Review.selectors';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesReviewContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import {
    ActivitiesReviewContainerClickEventActivitiesManifestV1,
    ActivitiesReviewContainerSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';
import ReviewListContainer from 'component/page/detail/Review/ReviewList/ReviewListContainer';
import { setSelectedTabOnDetailsPage } from 'component/page/detail/store/details';
import { selectScreenSize } from 'store/slice/screen';
import { InView } from 'react-intersection-observer';

const ReviewSection: React.FC<ReviewSectionProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const expandedAccordion = useSelector(selectExpandedAccordionFromDetailState);
    const isPrerender = useSelector(selectPrerenderStateFromBootstrap);
    const screenSize = useSelector(selectScreenSize);
    const reviewSectionState = expandedAccordion[`#${props.href}` || ''] && !isPrerender ? 'expanded' : 'collapsed';

    if (props.isHideReview) {
        return null;
    }
    const onSeen = (inView: boolean) => {
        if (inView && !props.isLoading && ((props.reviewList && props.reviewList.length > 0) || props.currentFilter.valueFilters.length > 0)) {
            trackElementEvent<ActivitiesReviewContainerSeenEventActivitiesFieldsV1>(ActivitiesReviewContainerSeenEventActivitiesManifestV1.ids, {
                is_toggle_on: reviewSectionState === 'expanded',
            });
        }
    };

    return (
        <Prerender.Hide>
            <InView onChange={onSeen} triggerOnce={true} threshold={1}>
                <DetailInViewWrapper tabHref={props.href || ''} isScrolling={props.isScrolling} setSelectedTabCallback={setSelectedTabOnDetailsPage}>
                    <Accordion
                        id={props.href}
                        contentSummary={cms[102057]}
                        actionType="chevron-icon"
                        onToggle={props.onToggle(`#${props.href}` || '', ActivitiesReviewContainerClickEventActivitiesManifestV1.ids)}
                        data-element-name="activities-review-container"
                        data-testid="activities-review-container"
                        level={2}
                        view={reviewSectionState}
                    >
                        {screenSize.tabletOrDesktop ? <ReviewListContainer isInOverlay={false} /> : <ReviewSummary />}
                        <ReviewOverlay />
                    </Accordion>
                </DetailInViewWrapper>
            </InView>
        </Prerender.Hide>
    );
};
ReviewSection.displayName = 'ReviewSection';

export default connect(mapStateToProps)(ReviewSection);
